import * as React from "react";
import Modal from "../../ui/modal/Modal";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

type Props = ComponentProps;

export default class ConfirmQuoteAcceptModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "600px"}}>
					<p>Changing status of quote to "Accepted" will automatically create a job.
						Would you like to proceed?</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Process"} onClick={() => {this.props.onConfirm()}}/>
					</div>
				</div>
			</Modal>
		)
	}
}
